import axios from 'axios';

const getBJ = (source_id: string, callback: any) =>
{
    let bj = {};
    if (source_id != '') {
        // we have a Gaia EDR3 id, so look up distance and coordinates from Bailer-Jones
        let vizierURL = 'https://vizier.u-strasbg.fr/viz-bin/asu-txt?-source=I%2F352%2Fgedr3dis&-out.add=_Glon%2C_Glat'
        vizierURL += '&-mime=csv&-out=_Glon%20_Glat%20rgeo%20rpgeo&-out.meta=-huD&Source='+source_id;
        console.log('trying BJ',vizierURL);
        axios.get(vizierURL)
        .then(response => {
            let response_data = (response.data as any).toString().trim();
            let data = response_data.split('#END#')[0].trim();
            data = data.split("\n");
            console.log('data',data);
            data = data.slice(-1)[0].split(';');
            if (data.length > 0) {
                let glon = data[0].trim();
                let glat = data[1].trim();
                let rgeo = data[2].trim();
                let rpgeo = data[3].trim();

                bj = {source_id, glon, glat, rgeo, rpgeo};

                callback(bj);
            }
        });
    } else {
        callback(bj);
    }
}

export const handleSearch = (s: string, callback: any, g: any, update: any) => {
    let r: any; // return data
    // replace this query function with one that uses the
    // dr3_object_coordinates_with_multiple_names.csv
    // file

    let lookupURL = 'https://gruze.org:3011/query?object='+encodeURIComponent(s);
    console.log('getting '+lookupURL);
    axios.get(lookupURL)
    .then((lookup_response: any) => {
        if (lookup_response.data) {
            // this is in the local catalog, so create the data response object
            let returnType = 'other';
            let data = lookup_response.data;
            callback({returnType,data},g,update);
        } else {
            // this is not in the local catalog, so see if it is in SIMBAD and has either a Hipparcos or Gaia EDR3 id.
            // If it has Gaia EDR3 id, get some SIMBAD data and then look up the distance in Bailer-Jones
            // If it does not have a Gaia EDR3 id but has a Hipparcos id, retrieve Hipparcos data from Vizier
            
            // if not in SIMBAD but is a Gaia EDR3 id, look it up in Bailer-Jones

            // after all this, create the data response object

            // start with old code and then fix up

            let mainName = '';
            let hip_id = '';
            let hd_id:string;
            let simbadURL = 'https://simbad.u-strasbg.fr/simbad/sim-script?submit=submit+script';
            simbadURL += '&script=format+object+f1+%22%25IDLIST%28SA%28+%7C+%29%3B1%2C*%2CHIP%2CHD%2C';
            simbadURL += 'Gaia%20EDR3%2CNAME%29%3B%25SP%28S%29%3B%25COO%28d%3B%3BGAL%29%3B%25FLUXLIST%28V%3BF%29%3B%25plx%22%0D%0A%0D%0Aquery+';
            simbadURL += encodeURIComponent(s);
            console.log('getting '+simbadURL);
            axios.get(simbadURL)
            .then(response => {

                // process the SIMBAD response
                let parallax:any;
                let error:any;
                let glon:number;
                let glat:number;
                let relMag:any;
                let mag:any;
                let plx;
                let plxSource;
                let errRatio;
                let distance:any;
                let distanceMinus:any;
                let distancePlus:any;
                let n;
                let source_id = '';
                let names = [];
                let starNames = [];
                let response_data = (response.data as any).toString();
                console.log(response_data);
                let status = response_data.split('\n').slice(-5)[0].slice(0,6);
                console.log(status);
                if (status == '::data') {
                    let d:any = response_data.split('\n').slice(-3)[0].split(';');
                    let name = d[0].split('|');
                    mainName = name[0].trim();
                    if (mainName.startsWith('* ')) {
                        mainName = mainName.slice(2);
                    } else if (mainName.startsWith('NAME ')) {
                        mainName = mainName.slice(5);
                    }
                    for (var i = 0; i < name.length; i++) {
                        n = name[i].trim()
                        if (n.startsWith('NAME ')) {
                            names.push(n.slice(5));
                        } else if (n.startsWith('Gaia EDR3 ')) {
                            source_id = n.slice(10);
                        } else if (n.startsWith('HIP ')) {
                            hip_id = n.slice(4);
                        } else if (n.startsWith('HD ')) {
                            hd_id = n.slice(3);
                        } else if (n.startsWith('* ')) {
                            starNames.push(n.slice(2));
                        }
                    }
                    let combinedNames = names.concat(starNames);
                    if (hd_id) {
                        combinedNames.push('HD '+hd_id);
                    }
                    let otherNames:any = [];
                    for (var i =0; i < combinedNames.length; i++) {
                        name = combinedNames[i];
                        if (name != mainName) {
                            otherNames.push(name);
                        }
                    }
                    
                    let otherNamesJoin = otherNames.join(' | ');
                    console.log(mainName,source_id,hip_id,names);
                    let spectrum = d[1].trim();
                    let coo = d[2].split(' ')[0];
                    if (coo.split('+').length == 2) {
                        coo = coo.split('+')
                        glat = parseFloat(coo[1]);
                    } else {
                        coo = coo.split('-');
                        glat = -parseFloat(coo[1]);
                    }
                    glon = parseFloat(coo[0])
                    relMag = d[3].trim();
                    console.log('relMag',relMag);
                    plx = d[4].split(' ');
                    console.log(plx);
                    plxSource = plx[3].trim();
                    parallax = plx[0].trim();
                    if (plx[0].trim() != '~') {
                        parallax = parseFloat(parallax);
                        if (plx[1].trim().slice(1,-1) != '~') {
                            error = parseFloat(plx[1].trim().slice(1,-1))
                            errRatio = error/parallax;
                        }
                    }

                    let simbad = {mainName,source_id,hip_id,hd_id,otherNamesJoin,spectrum,glon,glat,parallax,errRatio,plxSource,relMag};
                    if (source_id) {
                        let returnType = 'simbad_bj'
                        getBJ(source_id, (bj: any) => {callback({returnType,simbad,bj},g,update)});
                    } else {
                        let bj = {};
                        let returnType = 'simbad';
                        callback({returnType,simbad,bj},g,update);
                    }
                    
                } else {
                    // SIMBAD knows nothing about this id
                    // if this is a Gaia EDR3 id, try Bailer-Jones
                    if (s.toLowerCase().startsWith('gaia edr3 ')) {
                        source_id = s.slice(10);
                        getBJ(source_id, 
                            (bj: any) => {
                                let simbad = {};
                                let returnType = 'bj';
                                callback({returnType,simbad,bj},g,update);
                            }
                        );
                    } else {
                        let simbad = {};
                        let bj = {};
                        let returnType = 'fail';
                        callback({returnType,simbad,bj},g,update);
                    }
                }
            });
        }
    });
}